export default {
	"Publicity.ShopAnnouncements": "店铺公告",
	"Publicity.MarketingMallComponentClick": "营销商城_组件点击",
	"Publicity.MarketingMarketplace": "营销商城"
}